import { ChevronRight } from 'lucide-react'
import { StatusBadge } from '../common/StatusBadge'
import styles from '../CommandCenterApprovals.module.css'
import { isOverdue, reviewQueueLabel, reviewStatusLabel, reviewStatusTone, sourceLabel } from './moderationReviewModel'

function openedDate(value) {
  if (!value) return 'Opened time unavailable'
  return new Date(value).toLocaleDateString(undefined, { month: 'short', day: 'numeric' })
}

export function ReviewQueue({
  reviews = [],
  title = 'Needs review',
  selectedId,
  selectedButtonRef,
  disabled = false,
  hasMore = false,
  onLoadMore,
  onSelect,
}) {
  return (
    <section className={styles.queue} aria-labelledby="moderation-queue-title">
      <header className={styles.queueHeader}>
        <div>
          <h2 id="moderation-queue-title">{title}</h2>
          <span>{reviews.length}{hasMore ? '+' : ''} review{reviews.length === 1 ? '' : 's'}</span>
        </div>
      </header>

      <ul className={styles.queueList}>
        {reviews.map((review) => {
          const selected = selectedId === review.id
          const label = review.title || review.excerpt || 'Untitled post'
          return (
            <li key={review.id}>
              <button
                ref={selected ? selectedButtonRef : undefined}
                type="button"
                className={`${styles.queueItem} ${selected ? styles.queueItemSelected : ''}`.trim()}
                aria-pressed={selected}
                aria-label={reviewQueueLabel(review)}
                disabled={disabled}
                onClick={() => onSelect(review.id)}
              >
                <span className={styles.queueItemMain}>
                  <strong>{label}</strong>
                  <span>{sourceLabel(review.source)}</span>
                </span>
                <span className={styles.queueItemMeta}>
                  <StatusBadge status={reviewStatusTone(review.status)} size="small">{reviewStatusLabel(review.status)}</StatusBadge>
                  {isOverdue(review) ? <StatusBadge status="error" size="small">Overdue</StatusBadge> : null}
                  {review.self_review ? <StatusBadge status="info" size="small">Self-review</StatusBadge> : null}
                  {review.carried_from ? <StatusBadge status="info" size="small">Carried over</StatusBadge> : null}
                  {review.overturned ? <StatusBadge status="info" size="small">Overturned</StatusBadge> : null}
                  <span>{openedDate(review.created_at)}</span>
                </span>
                <ChevronRight className={styles.queueItemArrow} size={17} aria-hidden="true" />
              </button>
            </li>
          )
        })}
      </ul>

      {hasMore ? (
        <p className={styles.queueLimit}>
          <button type="button" onClick={onLoadMore} disabled={disabled}>Load more reviews</button>
        </p>
      ) : null}
    </section>
  )
}
